/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1rY2tZYbGa%3Adefined%3Adefined%3Adefined%7Bborder%3Anone%7D%0A._0IUicTdnbC%3Adefined%3Adefined%3Adefined%7Bpadding-top%3A0%7D%0A._2CPmtLdnbC%3Adefined%3Adefined%3Adefined%7Bpadding-right%3A0%7D%0A._3Ry02rdnbC%3Adefined%3Adefined%3Adefined%7Bpadding-bottom%3A0%7D%0A._0MZiGidnbC%3Adefined%3Adefined%3Adefined%7Bpadding-left%3A0%7D%0A._0JgUISdnbC%3Adefined%3Adefined%3Adefined%7Bmargin-top%3A0%7D%0A._2jBLLmdnbC%3Adefined%3Adefined%3Adefined%7Bmargin-right%3A0%7D%0A._35hjkkdnbC%3Adefined%3Adefined%3Adefined%7Bmargin-bottom%3A0%7D%0A._354XgOdnbC%3Adefined%3Adefined%3Adefined%7Bmargin-left%3A0%7D%0A._4rHKqQIZbP%3Adefined%3Adefined%3Adefined%7Binset%3Aauto%7D%0A._29vmT7YvD1%3Adefined%3Adefined%3Adefined%7Boverflow-x%3Avisible%7D%0A._38PkgEYvD1%3Adefined%3Adefined%3Adefined%7Boverflow-y%3Avisible%7D%0A._4bqM9MjOvk%3Adefined%3Adefined%3Adefined%7Bbackground-color%3Atransparent%7D%0A._1mTOXy1qpb%3Adefined%3Adefined%3Adefined%7Bflex-direction%3Arow%7D%0A._3QA2gZLRg7%3Adefined%3Adefined%3Adefined%7Bflex-wrap%3Anowrap%7D%0A._2Shm1hzUZr%3Adefined%3Adefined%3Adefined%7Balign-items%3Anormal%7D%0A._3Zo5bzzUZr%3Adefined%3Adefined%3Adefined%7Bjustify-content%3Anormal%7D%0A._3hz6pUy1CL%3Adefined%3Adefined%3Adefined%7Bposition%3Afixed%7D%0A._1JQPw0E6Kk%3Adefined%3Adefined%3Adefined%7Bwidth%3A-moz-fit-content%3Bwidth%3Afit-content%7D%0A._4coeiLIZbP%3Adefined%3Adefined%3Adefined%7Bheight%3Aauto%7D%0A._4DVkoZIZbP%3Adefined%3Adefined%3Adefined%7Bmin-width%3Aauto%7D%0A._1pYRymYbGa%3Adefined%3Adefined%3Adefined%7Bmax-width%3Anone%7D%0A._3sidotIZbP%3Adefined%3Adefined%3Adefined%7Bmin-height%3Aauto%7D%0A._0HFSp6YbGa%3Adefined%3Adefined%3Adefined%7Bmax-height%3Anone%7D%0A._3NthtFzUZr%3Adefined%3Adefined%3Adefined%7Balign-self%3Anormal%7D%0A._1hzzDPzUZr%3Adefined%3Adefined%3Adefined%7Bjustify-self%3Anormal%7D%0A._3n2izOYbGa%3Adefined%3Adefined%3Adefined%7Btransform%3Anone%7D%0A._2bmTl7YbGa%3Adefined%3Adefined%3Adefined%7Btranslate%3Anone%7D%0A._1Wet47YbGa%3Adefined%3Adefined%3Adefined%7Bscale%3Anone%7D%0A._4eTLRPYbGa%3Adefined%3Adefined%3Adefined%7Brotate%3Anone%7D%0A._2Q5CZ97dHp%3Adefined%3Adefined%3Adefined%7Bopacity%3A1%7D%0A._42w5E7Q4SZ%3Apopover-open%3Apopover-open%3Apopover-open%7Bdisplay%3Aflex%7D%0A%3Awhere(._0kCZAs7dHp)%3E*%7Bflex-grow%3A1%7D%0A%3Awhere(._4FizMIdnbC)%3E*%7Bmin-inline-size%3A0%7D%0A%3Awhere(._102crRdnbC)%3E*%7Bmin-block-size%3A0%7D%0A._1kOSYtHCFx%7Btransition-property%3Aoverlay%2Cdisplay%7D%0A._3Z9K0wPdtu%7Btransition-duration%3Avar(--ds-duration-xshort%2C.1s)%7D%0A._4f1LA5ThaV%7Btransition-behavior%3Aallow-discrete%7D%0A._3Y6bKpZSoF%7Banimation-fill-mode%3Aboth%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._0LqqFdYbGa%7Banimation-name%3Anone%7D._2Iz54kxlqh%7Btransition-duration%3Avar(--ds-duration-instant%2C0ms)%7D%7D%0A._2fBhte3Dhq%7Banimation%3Avar(--ds-popover-motion-enter)%7D%0A._2fBhteV1L6%7Banimation%3Avar(--ds-popover-motion-exit)%7D%0A._16fQCjIZbP%3Adefined%3Adefined%3Adefined%7Bpointer-events%3Aauto%7D%0A._22xN0BzUZr%3Adefined%3Adefined%3Adefined%7Bwhite-space%3Anormal%7D%0A._31O5bFzUZr%3Adefined%3Adefined%3Adefined%7Bword-break%3Anormal%7D%0A._3npKLMzUZr%3Adefined%3Adefined%3Adefined%7Boverflow-wrap%3Anormal%7D%0A._1W8Jgq7p2s%3Adefined%3Adefined%3Adefined%7Btext-align%3Astart%7D%0A._1sv16BdnbC%3Adefined%3Adefined%3Adefined%7Btext-indent%3A0%7D%0A._37eVqOYbGa%3Adefined%3Adefined%3Adefined%7Btext-transform%3Anone%7D%0A._0D9ajdy7kJ%3Adefined%3Adefined%3Adefined%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");

















































import React, { forwardRef, type Ref, useCallback, useId, useMemo, useRef } from 'react';
import { cx } from '@compiled/react';
import { bind } from 'bind-event-listener';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';
import once from '@atlaskit/ds-lib/once';
import { useLayoutEffect } from '@atlaskit/ds-lib/use-layout-effect';
import { requestCloseEventName } from '../internal/closable-popover-contract';
import { isNativeElementOpen } from '../internal/is-native-element-open';
import { resolvePlacement, type TPlacementAxis, type TPlacementEdge } from '../internal/resolve-placement';
import type { TBoostedSurfaceResetCheck } from '../internal/surface-reset';
import { useAnimatedVisibility } from '../internal/use-animated-visibility';
import { useFocusWrap } from '../internal/use-focus-wrap';
import { useInitialFocus } from '../internal/use-initial-focus';
import { type TPopoverCloseReason, type TPopoverForwardedProps } from './types';

/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */
function restoreFocus({
  popover,
  focusRestorationTarget
}: {
  popover: HTMLElement;
  focusRestorationTarget: HTMLElement | null;
}) {
  if (!focusRestorationTarget) {
    return;
  }
  const {
    ownerDocument
  } = popover;
  // Native restoration has finished. Preserve focus moved outside the popover.
  const activeElementAfterClose = ownerDocument.activeElement;
  // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
  if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) {
    // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
      preventScroll: true
    });
  }
}

/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */
const supportsPopoverHint = once((): boolean => {
  if (typeof document === 'undefined') {
    return false;
  }
  // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
  const element = document.createElement('div');
  element.setAttribute('popover', 'hint');
  return element.popover === 'hint';
});

/**
 * **Surface reset**
 *
 * The host is still a DOM child of its trigger for inheritance, so it inherits
 * values like `pointer-events: none` or `white-space: nowrap`. Resets them to
 * what `<body>` gave the portal path. `font` and direction still inherit.
 * Not `all: initial`: that would also override the UA `[popover]` rules.
 *
 * `color` is a reset too: the UA `[popover]` rule sets `color: CanvasText`, so
 * the host never inherits a colour. `color.text` is what `<body>` gave the portal
 * path. Not `inherit`, which would take the trigger's colour (for example a link).
 * See `notes/decisions/surface-reset-color.md`.
 *
 * KEEP IN SYNC with `dialog/dialog-content.tsx` (ADS forbids shared styles).
 * The `satisfies` check below catches drift.
 */
const surfaceResetStyles = {
  root: "_16fQCjIZbP _22xN0BzUZr _31O5bFzUZr _3npKLMzUZr _1W8Jgq7p2s _1sv16BdnbC _37eVqOYbGa _0D9ajdy7kJ"
};
(true satisfies TBoostedSurfaceResetCheck<typeof surfaceResetStyles.root, '&:defined:defined:defined'>);
const styles = {
  root: "_1rY2tZYbGa _0IUicTdnbC _2CPmtLdnbC _3Ry02rdnbC _0MZiGidnbC _0JgUISdnbC _2jBLLmdnbC _35hjkkdnbC _354XgOdnbC _4rHKqQIZbP _29vmT7YvD1 _38PkgEYvD1 _4bqM9MjOvk _1mTOXy1qpb _3QA2gZLRg7 _2Shm1hzUZr _3Zo5bzzUZr _3hz6pUy1CL _1JQPw0E6Kk _4coeiLIZbP _4DVkoZIZbP _1pYRymYbGa _3sidotIZbP _0HFSp6YbGa _3NthtFzUZr _1hzzDPzUZr _3n2izOYbGa _2bmTl7YbGa _1Wet47YbGa _4eTLRPYbGa _2Q5CZ97dHp _42w5E7Q4SZ _0kCZAs7dHp _4FizMIdnbC _102crRdnbC",
  motion: "_1kOSYtHCFx _3Z9K0wPdtu _4f1LA5ThaV _3Y6bKpZSoF _0LqqFdYbGa _2Iz54kxlqh",
  enter: "_2fBhte3Dhq",
  exit: "_2fBhteV1L6"
};

// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const popupMotionStyles: Record<TPlacementAxis, Record<TPlacementEdge, Record<string, string>>> = {
  block: {
    start: {
      '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
      '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    end: {
      '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
      '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
  },
  inline: {
    start: {
      '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
      '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    end: {
      '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
      '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
  }
};
type TPopoverMode = 'auto' | 'hint' | 'manual';

/**
 * Unopinionated top-layer primitive. Owns visibility and animation only;
 * compose with `useAnchoredPopover` for positioning and sizing.
 *
 * ### 🔌 Visibility
 *
 * - `isOpen={true}` calls `showPopover()` (entry via a keyframe animation).
 * - `isOpen={false}` calls `hidePopover()` (exit via a keyframe animation, kept
 *   visible by an `allow-discrete` transition).
 *
 * ### 📜 Browser dismiss is non-cancellable
 *
 * Per the popover spec, `beforetoggle` is cancellable on open transitions
 * only, not on close. Consumers should update controlled intent by setting
 * `isOpen` to `false` from `onClose`. If controlled intent remains open after
 * native close, the Popover remains closed until the prop changes.
 * `Dialog` asks first instead; see `notes/decisions/dialog-close-flow.md`.
 *
 * - Spec: <https://html.spec.whatwg.org/multipage/popover.html#the-popover-attribute>
 * - <https://github.com/whatwg/html/issues/8973>
 *
 * ### ⚠️ Open from `onClick`, not `onPointerDown`
 *
 * The light-dismiss algorithm captures the pointerdown target before the
 * popover exists and dismisses on the matching pointerup if that target is
 * not in the popover's ancestor chain. Opening during pointerdown hides
 * the popover on the next pointerup.
 *
 * Legacy triggers that must open on mousedown (e.g. `@atlaskit/react-select`)
 * should defer the open past the in-flight gesture; see
 * `Select.openMenuAfterPointerUp`.
 */
export const Popover: React.ForwardRefExoticComponent<TPopoverForwardedProps & React.RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, TPopoverForwardedProps>(function Popover({
  children,
  mode: modeProp = 'auto',
  onClose,
  onEnterFinish,
  onExitFinish,
  shouldAnimate = false,
  placement,
  testId,
  isOpen,
  enteringAnimationXcss,
  exitingAnimationXcss,
  initialFocusRef,
  UNSAFE__disableInitialAutoFocus = false,
  // ARIA
  role,
  label,
  labelledBy,
  id: idProp
}, ref) {
  const autoId = useId();
  const ownRef = useRef<HTMLDivElement>(null);
  const combinedRef = mergeRefs(([ownRef, (ref as Ref<HTMLDivElement>)].filter(Boolean) as Array<Ref<HTMLDivElement>>));
  // `useId()` colons are invalid in CSS selectors and popover target attributes.
  const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;

  // Keep the semantic callback current without rebinding native lifecycle
  // listeners during the same commit that calls showPopover()/hidePopover().
  const onCloseRef = useRef(onClose);
  useLayoutEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  // A popover with `onClose` is closable (see `closable-popover-contract`).
  // `requestClosePopovers()` asks it to close; the consumer decides.
  const isClosable = Boolean(onClose);

  // `hint` falls back to `auto` when unsupported: closest behavior (light
  // dismiss works), but `auto` participates in the auto-dismiss stack so it
  // will close other `auto` popovers when opened. Acceptable trade-off given
  // shrinking browser set without `hint` support.
  const mode: TPopoverMode = modeProp === 'hint' && !supportsPopoverHint() ? 'auto' : modeProp;
  const popupMotionStyle = useMemo(() => {
    if (!placement || !shouldAnimate) {
      return undefined;
    }
    const {
      axis,
      edge
    } = resolvePlacement({
      placement
    });
    return popupMotionStyles[axis][edge];
  }, [placement, shouldAnimate]);

  // Tracks the close reason, including our own hidePopover() calls.
  const closeReasonRef = useRef<TPopoverCloseReason>('light-dismiss');

  // Pre-open focus target, cleared before close when restoration is not eligible.
  const focusRestorationTargetRef = useRef<HTMLElement | null>(null);
  const handleBeforeToggle = useCallback((event: ToggleEvent) => {
    const popover = event.currentTarget;
    if (!(popover instanceof HTMLElement)) {
      return;
    }
    const {
      ownerDocument
    } = popover;
    const {
      activeElement
    } = ownerDocument;
    if (event.newState === 'open') {
      focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
      return;
    }

    /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */
    if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) {
      focusRestorationTargetRef.current = null;
    }
  }, []);
  const handleToggleClosed = useCallback((event: ToggleEvent) => {
    const popover = event.currentTarget;
    if (!(popover instanceof HTMLElement)) {
      return;
    }
    const focusRestorationTarget = focusRestorationTargetRef.current;
    focusRestorationTargetRef.current = null;
    const reason = closeReasonRef.current;
    // Reset reason so a stale 'escape' from a race with Escape keydown
    // does not corrupt the next browser-dismiss cycle.
    closeReasonRef.current = 'light-dismiss';

    // Run after native restoration, before notifying the consumer, which may move focus itself.
    restoreFocus({
      popover,
      focusRestorationTarget
    });

    // Programmatic closes are already known to the consumer.
    if (reason !== 'programmatic') {
      onCloseRef.current?.({
        reason
      });
    }
  }, []);
  const {
    phase,
    isMounted,
    onBeforeToggle,
    onToggle
  } = useAnimatedVisibility({
    isOpen,
    shouldAnimate,
    elementRef: ownRef,
    onEnterFinish,
    onExitFinish
  });

  // Focus management: Tab cycling for dialog roles. Initial focus is below
  // the show/hide layout effect. Restoration is native for outermost
  // popovers; nested popovers are handled above via the `beforetoggle`
  // snapshot. Passing `phase` keeps `useFocusWrap` attached through the
  // animated-exit window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
  useFocusWrap({
    elementRef: ownRef,
    role,
    phase
  });

  // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
  // below, so listeners are attached when `showPopover()` synchronously
  // dispatches `beforetoggle`. A regular `useEffect` would miss that
  // first dispatch, dropping the `focusRestorationTargetRef` snapshot
  // and breaking nested-popover focus restoration on close. React runs
  // layout effects in source order on the same commit.
  useLayoutEffect(() => {
    const element = ownRef.current;
    if (!element) {
      return;
    }

    // Tag Escape before the browser processes light dismiss.
    const unbindEscape = bind(element, {
      type: 'keydown',
      listener: (event: KeyboardEvent) => {
        // Ignore Escape events dispatched after native close.
        if (event.key === 'Escape' && isNativeElementOpen({
          element
        })) {
          closeReasonRef.current = 'escape';
        }
      },
      options: {
        capture: true
      }
    });
    const unbindToggle = bind(element, {
      type: 'toggle',
      listener: (event: ToggleEvent) => {
        if (event.newState === 'closed') {
          handleToggleClosed(event);
        }
        onToggle(event);
      }
    });
    // Snapshot the active element before `useInitialFocus` moves it,
    // then advance the shared visibility lifecycle.
    const unbindBeforeToggle = bind(element, {
      type: 'beforetoggle',
      listener: (event: ToggleEvent) => {
        handleBeforeToggle(event);
        onBeforeToggle(event);
      }
    });

    // `requestClosePopovers()` asks the consumer to close. Nothing is
    // hidden here, so a consumer that keeps `isOpen` stays in sync.
    const unbindRequestClose = bind(element, {
      type: requestCloseEventName,
      listener: () => {
        onCloseRef.current?.({
          reason: 'programmatic'
        });
      }
    });
    return () => {
      unbindEscape();
      unbindToggle();
      unbindBeforeToggle();
      unbindRequestClose();
    };
  }, [handleBeforeToggle, handleToggleClosed, isMounted, onBeforeToggle, onToggle]);

  // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
  // already in the target state. Try/catch guards `InvalidStateError` on
  // disconnected elements (StrictMode/concurrent/unmount edge cases).
  useLayoutEffect(() => {
    const element = ownRef.current;
    if (!element) {
      return;
    }
    if (isOpen) {
      // Clear stale 'escape' from a prior cycle: the ref outlives
      // the host element, and interrupted close lifecycles may not reach
      // `handleToggleClosed` to reset it.
      closeReasonRef.current = 'light-dismiss';
      try {
        element.showPopover();
      } catch {}
      return () => {
        closeReasonRef.current = 'programmatic';
        try {
          element.hidePopover();
        } catch {}
      };
    }
    closeReasonRef.current = 'programmatic';
    try {
      element.hidePopover();
    } catch {}
  }, [isOpen]);

  // Initial focus (role-dependent) is a layout effect, so it must come AFTER
  // the show/hide layout effect above: React runs layout effects in source
  // order, and focus only works once `showPopover()` has run. Focus then
  // lands in the same task as the open, before the browser paints.
  useInitialFocus({
    elementRef: ownRef,
    isEnabled: !UNSAFE__disableInitialAutoFocus,
    initialFocusRef,
    phase,
    role
  });

  // Unmount the host once exit completes so it does not leave an empty
  // `role`/`popover` element in the accessibility tree. The element
  // remounts on the next open; the `popoverId` is stable across opens.
  if (!isMounted) {
    return null;
  }
  return <div ref={combinedRef} id={popoverId}
  // @ts-expect-error -- popover attribute not yet in React types
  // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
  popover={mode} role={role}
  // Keep in sync with `closablePopoverAttribute` (internal/closable-popover-contract).
  data-top-layer-closable={isClosable ? '' : undefined} aria-label={label} aria-labelledby={labelledBy} data-testid={testId}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
  style={popupMotionStyle}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
  className={ax([styles.root, surfaceResetStyles.root, shouldAnimate && phase === 'entering' && styles.enter, shouldAnimate && phase === 'exiting' && styles.exit, shouldAnimate && styles.motion, cx(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)])}>
			{children}
		</div>;
});